import { useLayoutEffect, useState } from "react";
import useResizeObserver from "../../hooks/useResizeObserver";
import { getFocusableChildren } from "../../utils/keyboard";
function isOverflowingRect(rect) {
    return rect.scrollWidth > rect.clientWidth || rect.scrollHeight > rect.clientHeight;
}
/**
 * Returns required props to make a container accessible
 *
 * If container is detected to be scrollable and does not have any focusable elements
 * inside then it needs a tabIndex to make it focusable.
 *
 */
const useAccessibleContainer = (element) => {
    const rect = useResizeObserver(element);
    const hasFocusableChildren = element && getFocusableChildren(element).length > 0;
    useLayoutEffect(() => {
        setScrollableContainerProps(rect && isOverflowingRect(rect) && !hasFocusableChildren ? { tabIndex: 0 } : undefined);
    }, [rect]);
    const [scrollableContainerProps, setScrollableContainerProps] = useState();
    return scrollableContainerProps;
};
export default useAccessibleContainer;
//# sourceMappingURL=useAccessibleContainer.js.map